import clsx from 'clsx';
import styles from './Spinner.module.css';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  /** Accessible label; pass `null` when a surrounding element already announces busy state. */
  label?: string | null;
  className?: string;
}

/** Indeterminate activity indicator (inherits `currentColor`). */
export function Spinner({ size = 'md', label = 'Loading…', className }: SpinnerProps) {
  return (
    <span
      className={clsx(styles.spinner, styles[size], className)}
      role={label ? 'status' : undefined}
      aria-label={label ?? undefined}
      aria-hidden={label ? undefined : true}
    >
      <svg viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.2" strokeWidth="3" />
        <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      </svg>
    </span>
  );
}

/** Centered spinner filling its container (route/section loading states). */
export function LoadingBlock({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className={styles.block}>
      <Spinner size="lg" label={label} />
    </div>
  );
}
